import { render, staticRenderFns } from "./CuisineProfile.vue?vue&type=template&id=524a2fe0&scoped=true&"
import script from "./CuisineProfile.vue?vue&type=script&lang=js&"
export * from "./CuisineProfile.vue?vue&type=script&lang=js&"
import style0 from "./CuisineProfile.vue?vue&type=style&index=0&id=524a2fe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524a2fe0",
  null
  
)

export default component.exports